import { Pipe, PipeTransform } from '@angular/core';

import { ShippingStopKindEnum } from '../enums/shipping-stop-kind.enum';
import { IShippingStop } from '../interfaces/shipping-stop.interface';

@Pipe({ name: 'shippingStopKind' })
export class ShippingStopKindPipe implements PipeTransform {
  transform(stop: IShippingStop, kind: 'icon' | 'literal') {
    if (stop.kind === ShippingStopKindEnum.PICKUP) {
      return kind === 'icon' ? 'moped' : 'Coleta';
    } else if (stop.kind === ShippingStopKindEnum.DROPOFF) {
      return kind === 'icon' ? 'hand_package' : 'Entrega';
    } else {
      return kind === 'icon' ? '' : 'Parada';
    }
  }
}
